import cx from 'clsx'
import { PropsWithChildren } from 'react'

interface Props {
  className: string
}

export function Layout({ className, children }: PropsWithChildren<Props>) {
  return <div className={cx(className, 'faq-layout')}>{children}</div>
}
